exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warehouse_from_WarehousesLocations-css_3Rl {\n  margin-top: 32px;\n  padding-top: 32px;\n  border-top: 1px dashed #9f9ea9\n}\n.warehouse_from_WarehousesLocations-css_3Rl:first-child {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: none;\n}\n.warehouse_from_WarehousesLocations-css_3Rl h1 {\n  margin-bottom: 8px;\n}\n.warehouse_from_WarehousesLocations-css_3Rl p {\n  margin-top: 3px;\n}\n", ""]);

// exports
exports.locals = {
	"warehouse": "warehouse_from_WarehousesLocations-css_3Rl"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/components/layout/WarehousesLocations/WarehousesLocations.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/WarehousesLocations/WarehousesLocations.css
// module chunks = 0